import { useEffect, useState } from 'react';
import { Loader2, ScanLine } from 'lucide-react';

// Animated "reading your ticket…" meter. Eases toward ~92% over ~est seconds so
// the bar never looks stuck, then the parent unmounts it when the scan returns.
export const ScanProgress = ({ estMs = 15000, label = 'Reading your ticket…' }) => {
    const [pct, setPct] = useState(6);
    useEffect(() => {
        const start = Date.now();
        const id = setInterval(() => {
            const t = (Date.now() - start) / estMs;
            // ease-out curve, capped at 92% until the real response arrives
            const next = Math.min(92, 6 + 86 * (1 - Math.exp(-1.7 * t)));
            setPct(next);
        }, 120);
        return () => clearInterval(id);
    }, [estMs]);
    return (
        <div className="rounded-xl border border-[#FF007F]/30 bg-[#FF007F]/5 p-4" data-testid="scan-progress">
            <div className="flex items-center gap-2 mb-2">
                <Loader2 className="w-4 h-4 animate-spin text-[#FF007F]" />
                <ScanLine className="w-4 h-4 text-[#FF007F]" />
                <span className="text-sm font-bold text-white">{label}</span>
                <span className="ml-auto text-xs font-mono text-[#FF007F]" data-testid="scan-progress-pct">{Math.round(pct)}%</span>
            </div>
            <div className="h-2 w-full rounded-full bg-white/10 overflow-hidden">
                <div className="h-full rounded-full bg-gradient-to-r from-[#FF007F] to-[#FFD700] transition-[width] duration-150 ease-out"
                     style={{ width: `${pct}%` }} data-testid="scan-progress-bar" />
            </div>
            <p className="text-[10px] text-[#A0AAB2] mt-1.5">Analyzing handwriting & matching the customer — usually about 15 seconds.</p>
        </div>
    );
};

export default ScanProgress;
